import React, { Component } from "react";

export default class StudyGroupUserTitle extends Component {
  render() {
    return <h3 className="groups-user-title">{this.props.title}</h3>;
  }
}



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserTitle.jsx